import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import HeaderContainer from '../Header/HeaderContainer';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Footer from '../../components/Footer/';
import { connect } from 'react-redux';
import DashboardContainer from '../Dashboard/DashboardContainer';
import ClientsContainer from '../Clients/ClientsContainer';
import CapacityContainer from '../Capacity/CapacityContainer';
import BaseRatesViewContainer from '../BaseRates/BaseRatesViewContainer';
import AccessorialsAndFeesViewContainer from '../AccessorialsAndFees/AccessorialsAndFeesViewContainer';
import SettingsContainer from '../Settings/SettingsContainer';

import JobsContainer from '../Jobs/JobsContainer';
import UsersContainer from '../Users/UsersContainer';
import { isAuthenticated } from '../Authentication/LoginActions';
import { ToastContainer, toast } from 'react-toastify';

const containerStyle = {
  zIndex: 1999
};

class Full extends Component {

  componentDidMount(){
    const {dispatchIsLoggedIn} = this.props;
    dispatchIsLoggedIn();
  }
  render() {
    let isAuthenticated = this.props.isAuthenticated;
    if (!isAuthenticated) {
      return <Redirect to='/login' />;
    }
    let url = this.props.match.url;

    let container = null;

    switch (this.props.orgType) {
      case "CLIENT":
        container = <Switch>
          <Route exact path={`${url}`} name="Dashboard" component={DashboardContainer} />
          <Route path={`${url}/jobs`} name="Jobs" component={JobsContainer} />
          <Route path={`${url}/users`} name="Users" component={UsersContainer} />
        </Switch>;
        break;
      case "GUEST":
        container = <Switch>
          <Route exact path={`${url}`} name="Dashboard" component={DashboardContainer} />
          <Route path={`${url}/jobs`} name="Jobs" component={JobsContainer} />
        </Switch>;
        break;

      default:
        container = <Switch>
          <Route exact path={`${url}`} name="Dashboard" component={DashboardContainer} />
          <Route path={`${url}/jobs`} name="Jobs" component={JobsContainer} />
          <Route path={`${url}/clients`} name="Clients" component={ClientsContainer} />
          <Route path={`${url}/users`} name="Users" component={UsersContainer} />
          <Route path={`${url}/capacity`} name="Capacity" component={CapacityContainer} />
          <Route path={`${url}/base-rates`} name="Base Rates" component={BaseRatesViewContainer} />
          <Route path={`${url}/accessorials`} name="Accessorials" component={AccessorialsAndFeesViewContainer} />
          <Route path={`${url}/settings`} name="settings" component={SettingsContainer} />
        </Switch>;

    }

    return (
      <div className="app">
        <HeaderContainer />
        <div className="app-body">
          <Sidebar {...this.props} client={this.props.orgType === "CLIENT"} />
          <main className="main">
            <ToastContainer position="top-left" autoClose={15000} style={containerStyle} />
            <Breadcrumb />
            <Container fluid>
              {container}
            </Container>
          </main>
          {/* <Aside /> */}
        </div>
        <Footer />
      </div>
    );

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchIsLoggedIn: () => dispatch(isAuthenticated())
  };
};

const mapStateToProps = (state) => {
  let self = state.self.get('data');
  let orgType = self ? self.organization.orgType : null;

  return {
    isAuthenticated: state.authentication.login.get('isAuthenticated'),
    orgType: orgType
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js